(function($) {
  $.validator.addMethod(
    "notequal",
    function(value, element, params) {
      return this.optional(element) || value !== params;
    },
    "Please select Role"
  );

  function make_base_auth(user, password) {
    var tok = user + ":" + password;
    var hash = btoa(tok);
    return "Basic " + hash;
  }

  var formLogin = $("#js--login");
  var formRegistration = $("#js--registration");
  var formForgotPassword = $("#js--forgot-password");
  var formProfile = $("#js--profile-form");
  var formUpdatePassword = $("#js--update-password");

  // prevent default for auth forms
  formForgotPassword.submit(function(ev) {
    ev.preventDefault();
  });

  formRegistration.submit(function(ev) {
    ev.preventDefault();
  });

  formLogin.submit(function(ev) {
    ev.preventDefault();
  });

  formProfile.submit(function(ev) {
    ev.preventDefault();
  });

  formUpdatePassword.submit(function(ev) {
    ev.preventDefault();
  });

  formLogin.validate({
    errorElement: "span",
    errorPlacement: function(error, element) {
      error.appendTo(element.parent(".c-form__group"));
    },
    rules: {
      p_email: {
        required: true,
        email: true
      },
      p_password: {
        required: true
      }
    },
    messages: {
      p_email: {
        required: "This field is reqired",
        email: "Enter valid email"
      },
      p_password: {
        required: "Please provide a password"
      }
    },
    submitHandler: function(form) {
      $(".js--message").hide();
      var username = $("[name=p_email]").val();
      var password = $("[name=p_password]").val();
      $(form)
        .find('[type="submit"]')
        .attr("disabled", "disabled");
      $.ajax({
        type: "POST",
        url: ajaxurl,
        dataType: "json",
        data: {
          action: "msc_api_call",
          type: "login",
          body: JSON.stringify({ p_email: username, p_password: password })
        },
        beforeSend: function() {
          $(".js--message").hide();
          $("button#login-btn").addClass("is-disabled");
          $("button#login-btn").append(
            '<span class="c-primary-button-icon-loading"></span>'
          );
        },
        success: function(response) {
          $(".js--message").hide();
          if (response.success) {
            window.location = response.redirect
              ? response.redirect
              : "/dashboard/";
          } else {
            $(".js--message-error").html(response.data.errors);
            $(".js--message-error").show();
            $(".c-primary-button-icon-loading").remove();
            $("button#login-btn").removeClass("is-disabled");
          }
        },
        error: function(xhr, ajaxOptions, thrownError) {
          $(".c-primary-button-icon-loading").remove();
          $("button#login-btn").removeClass("is-disabled");

          var response = JSON.parse(xhr.responseText);
          if (response && response.errors && response.errors.length > 0) {
            $(".js--message-error").html("");
            response.errors.forEach(function(error) {
              $(".js--message-error").append("<span>" + error + "</span>");
            });
            $(".js--message-error").show();
            return;
          }
          $(".js--message-error")
            .text("Something goes wrong. Please try again later")
            .show();
          $(form)
            .find('[type="submit"]')
            .remoteAttr("disabled");
        }
      });
    }
  });

  formUpdatePassword.validate({
    errorElement: "span",
    errorPlacement: function(error, element) {
      error.appendTo(element.parent(".c-form__group"));
    },
    rules: {
      p_email: {
        required: true,
        email: true
      },
      p_password: {
        required: true,
        minlength: 8
      },
      p_password_confirmation: {
        required: true,
        equalTo: "#p_password"
      }
    },
    messages: {
      p_email: {
        required: "This field is reqired",
        email: "Enter valid email"
      },
      p_password: {
        required: "Please provide a password",
        minlength: "Password should have at least 8 symbols"
      },
      p_password_confirmation: {
        required: "Please provide a password",
        equalTo: "Password and password confirmation doesn't match"
      }
    },
    submitHandler: function(form) {
      $(".js--message").hide();
      var username = $("[name=p_email]").val();
      var password = $("[name=p_password]").val();
      $(form)
        .find('[type="submit"]')
        .attr("disabled", "disabled");
      $.ajax({
        type: "POST",
        url: ajaxurl,
        dataType: "json",
        data: {
          action: "msc_api_call",
          type: "update_password",
          body: JSON.stringify({ p_email: username, p_password: password })
        },
        beforeSend: function() {
          $(".js--message").hide();
          $("button#submit-btn").addClass("is-disabled");
          $("button#submit-btn").append(
            '<span class="c-primary-button-icon-loading"></span>'
          );
        },
        success: function(response) {
          $(".c-primary-button-icon-loading").remove();
          $("button#submit-btn").removeClass("is-disabled");
          $(".js--message")
            .html("")
            .hide();
            $(form).find('input[type=password]').val('');
          var code = response.data ? response.data.code : null;
          switch (code) {
            case 404:
            case 202:
              $(".js--message-success")
                .text(response.data.properties.Result)
                .show();

              break;
            case 400:
              var errors = response.data ? response.data.errors : false;
              if (errors && errors.length > 0) {
                errors.forEach(function(error) {
                  $(".js--message-error").append("<span>" + error + "</span>");
                });
                $(".js--message-error").show();
              } else {
                $(".js--message-error").html(
                  "Something went wrong. Try again later"
                );
              }
              break;
            default:
              $(".js--message-error").html(
                "Something went wrong. Try again later"
              );
          }
        },
        error: function(xhr, ajaxOptions, thrownError) {
          $(".c-primary-button-icon-loading").remove();
          $("button#login-btn").removeClass("is-disabled");

          var response = JSON.parse(xhr.responseText);
          if (response && response.errors && response.errors.length > 0) {
            $(".js--message-error").html("");
            response.errors.forEach(function(error) {
              $(".js--message-error").append("<span>" + error + "</span>");
            });
            $(".js--message-error").show();
            return;
          }
          $(".js--message-error")
            .text("Something goes wrong. Please try again later")
            .show();
          $(form)
            .find('[type="submit"]')
            .remoteAttr("disabled");
        }
      });
    }
  });

  formForgotPassword.validate({
    errorElement: "span",
    errorPlacement: function(error, element) {
      error.appendTo(element.parent(".c-form__group"));
    },
    rules: {
      p_email: {
        required: true,
        email: true
      }
    },
    messages: {
      p_email: {
        required: "This field is reqired",
        email: "Enter valid email"
      }
    },
    submitHandler: function(form) {
      var email = $("[name=p_email]").val();
      $(form)
        .find('[type="submit"]')
        .attr("disabled", "disabled");
      $(".js--message").hide();
      $.ajax({
        type: "POST",
        url: ajaxurl,
        data: {
          action: "msc_api_call",
          type: "reset_password",
          body: JSON.stringify({ p_email: email })
        },
        beforeSend: function() {
          $(".js--message").hide();
          $("button#forgot-btn").addClass("is-disabled");
          $("button#forgot-btn").append(
            '<span class="c-primary-button-icon-loading"></span>'
          );
        },
        success: function(response) {
          $(".c-primary-button-icon-loading").remove();
          $("button#forgot-btn").removeClass("is-disabled");
          $(".js--message")
            .html("")
            .hide();
          var code = response.data ? response.data.code : null;
          switch (code) {
            case 404:
            case 202:
              $(".js--message-success")
                .text(response.data.properties.Result)
                .show();
              break;
            case 400:
              var errors = response.data ? response.data.errors : false;
              if (errors && errors.length > 0) {
                errors.forEach(function(error) {
                  $(".js--message-error").append("<span>" + error + "</span>");
                });
                $(".js--message-error").show();
              } else {
                $(".js--message-error").html(
                  "Something went wrong. Try again later"
                );
              }
              break;
            default:
              $(".js--message-error").html(
                "Something went wrong. Try again later"
              );
          }
        },
        error: function(xhr, ajaxOptions, thrownError) {
          $(".c-primary-button-icon-loading").remove();
          $("button#forgot-btn").removeClass("is-disabled");

          $(".js--message").hide();
          var response = JSON.parse(xhr.responseText);
          if (response && response.errors && response.errors.length > 0) {
            $(".js--message-error").html("");
            response.errors.forEach(function(error) {
              $(".js--message-error").append("<span>" + error + "</span>");
            });
            $(".js--message-error").show();
            return;
          }
          $(".js--message-error")
            .text("Something goes wrong. Please try again later")
            .show();
          $(form)
            .find('[type="submit"]')
            .remoteAttr("disabled");
        }
      });
    }
  });

  formRegistration.validate({
    // we need this to make validation work for terms checkbox
    ignore: ['[name="terms"]'],
    errorElement: "span",
    errorPlacement: function(error, element) {
      error.appendTo(element.parent(".c-form__group"));
    },
    rules: {
      p_first_name: {
        required: true
      },
      p_last_name: {
        required: true
      },
      p_email: {
        required: true,
        email: true
      },
      p_company: {
        required: true
      },
      p_position: {
        required: true
      },
      p_market: {
        required: true,
        notequal: "-1"
      },
      p_role: {
        required: true,
        notequal: "-1"
      },
      terms: {
        required: true
      }
    },
    messages: {
      p_first_name: {
        required: "This field is required"
      },
      p_last_name: {
        required: "This field is required"
      },
      p_email: {
        required: "This field is required",
        email: "Enter valid email"
      },
      p_company: {
        required: "This field is required"
      },
      p_position: {
        required: "This field is required"
      },
      p_market: {
        required: "This field is required"
      },
      p_role: {
        required: "This field is required",
        notequal: "This field is required"
      },
      terms: {
        required: "Accept our policy"
      }
    },
    submitHandler: function(form) {
      $(".js--message").hide();
      var mchmp = {
          f_name:   $("[name=p_first_name]").val(),
          l_name:   $("[name=p_last_name]").val(),
          email:    $("[name=p_email]").val(),
          company:  $("[name=p_company]").val(),
          country: $("[name=p_market] :selected").text(),
          subscribed:  $("[name=mc4wp-subscribe]").is(':checked'),
      };
      var data = {
        p_name:
          $("[name=p_first_name]").val() + " " + $("[name=p_last_name]").val(),
        p_email: $("[name=p_email]").val(),
        p_company: $("[name=p_company]").val(),
        p_position: $("[name=p_position]").val(),
        p_market: $("[name=p_market]").val(),
        p_role: $("[name=p_role]").val()
      };
      $(form)
        .find('[type="submit"]')
        .attr("disabled", "disabled");

      $.ajax({
        type: "POST",
        url: ajaxurl,
        data: {
          action: "msc_api_call",
          type: "request_access",
          body: JSON.stringify(data),
          mchmp_data: JSON.stringify(mchmp),
        },
        beforeSend: function() {
          $(".js--message").hide();
          $("button#register-btn").addClass("is-disabled");
          $("button#register-btn").append(
            '<span class="c-primary-button-icon-loading"></span>'
          );
        },
        success: function(response) {
          $("button#register-btn").removeClass("is-disabled");
          $(".c-primary-button-icon-loading").remove();
          $(".js--message").hide();

            window.location = response.data.redirect_url;
        },
        error: function(xhr, ajaxOptions, thrownError) {
          $("button#register-btn").removeClass("is-disabled");
          $(".js--message").hide();
          var response = xhr.responseText ? JSON.parse(xhr.responseText) : null;
          if (response && response.errors && response.errors.length > 0) {
            $(".js--message-error").html("");
            response.errors.forEach(function(error) {
              $(".js--message-error").append("<span>" + error + "</span>");
            });
            $(".js--message-error").show();
            return;
          }
          $(".js--message-error")
            .text("Something goes wrong. Please try again later")
            .show();
        }
      });
    }
  });

  formProfile.validate({
    // we need this to make validation work for terms checkbox
    errorElement: "span",
    errorPlacement: function(error, element) {
      error.appendTo(element.parent(".c-form__group"));
    },
    rules: {
      p_first_name: {
        required: true
      },
      p_last_name: {
        required: true
      },
      p_email: {
        required: true,
        email: true
      },
      p_company: {
        required: true
      },
      p_position: {
        required: true
      },
      p_market: {
        required: true,
        notequal: "-1"
      },
      p_role: {
        required: true,
        notequal: "-1"
      },
    },
    messages: {
      p_first_name: {
        required: "This field is required"
      },
      p_last_name: {
        required: "This field is required"
      },
      p_email: {
        required: "This field is required",
        email: "Enter valid email"
      },
      p_company: {
        required: "This field is required"
      },
      p_position: {
        required: "This field is required"
      },
      p_market: {
        required: "This field is required"
      },
      p_role: {
        required: "This field is required",
        notequal: "This field is required"
      },
    },
    submitHandler: function(form) {
      $(".js--message").hide();
      var data = {
        user_name:
          $("[name=p_first_name]").val() + " " + $("[name=p_last_name]").val(),
        user_email: $("[name=p_email]").val(),
        company_name: $("[name=p_company]").val(),
        company_position: $("[name=p_position]").val(),
        country_company_name: $("[name=p_market]").val(),
        company_role: $("[name=p_role]").val()
      };
      $(form)
        .find('[type="submit"]')
        .attr("disabled", "disabled");

      $.ajax({
        type: "POST",
        url: ajaxurl,
        data: {
          action: "msc_api_call",
          type: "update_profile",
          body: JSON.stringify(data)
        },
        beforeSend: function() {
          $(".js--message").hide();
          $("button#register-btn").addClass("is-disabled");
          $("button#register-btn").append(
            '<span class="c-primary-button-icon-loading"></span>'
          );
        },
        success: function(response) {
          $(".c-primary-button-icon-loading").remove();
          $("button#forgot-btn").removeClass("is-disabled");
          $(".js--message")
            .html("")
            .hide();
          var code = response.data ? response.data.code : null;
          switch (code) {
            case 404:
            case 202:
              $(".js--message-success")
                .text(response.data.properties.Result)
                .show();
              break;
            case 400:
              var errors = response.data ? response.data.errors : false;
              if (errors && errors.length > 0) {
                errors.forEach(function(error) {
                  $(".js--message-error").append("<span>" + error + "</span>");
                });
                $(".js--message-error").show();
              } else {
                $(".js--message-error").html(
                  "Something went wrong. Try again later"
                );
              }
              break;
            default:
              $(".js--message-error").html(
                "Something went wrong. Try again later"
              );
          }
          $("button#register-btn").removeClass("is-disabled");
        },
        error: function(xhr, ajaxOptions, thrownError) {
          $("button#register-btn").removeClass("is-disabled");
          $(".js--message").hide();
          var response = xhr.responseText ? JSON.parse(xhr.responseText) : null;
          if (response && response.errors && response.errors.length > 0) {
            $(".js--message-error").html("");
            response.errors.forEach(function(error) {
              $(".js--message-error").append("<span>" + error + "</span>");
            });
            $(".js--message-error").show();
            return;
          }
          $(".js--message-error")
            .text("Something goes wrong. Please try again later")
            .show();
        }
      });
    }
  });
})(jQuery);